import { Expression } from './Expression.js';
export class EnumerationExpression extends Expression {
    constructor(source) {
        super();
        const [enumeration, field] = source.split('::');
        this.enumeration = enumeration;
        this.field = field;
    }
    evaluate(visitor) {
        const enumeration = visitor.getRegisteredEnumeration(this.enumeration);
        if (enumeration) {
            return enumeration[this.field];
        }
    }
}
//# sourceMappingURL=EnumerationExpression.js.map